module.exports = __webpack_public_path__ + "img/140.613674f8.gif";